module.exports = __webpack_public_path__ + "static/img/120002.f18a18f9.png";